import Header from "../../../common/Header/Header";
import { useState } from "react";
import SelectRawProducts from "./SelectRawProducts";
import SelectSpecs from "./SelectSpecs";
import { RawProd } from "../../../services/rawProd/rawProd.types";
import { Spec } from "../../../services/spec/spec.types";
import ConfirmChanges from "./ConfirmChanges";
import { useUpdateSubRecipeDetailsRawProducts } from "../../../services/subrecipe/subrecipe.service";
import Review from "./Review";
import { ChangeRawProductsBody } from "./ChangeRawProducts.styles";

export interface ChangeRawProductOperation {
  currentRawProduct: RawProd,
  desiredRawProduct: RawProd
}

export enum ChangeOptionRecipeRawProductsStep {
  SelectRawProducts,
  SelectSpecs,
  ConfirmChanges,
  Review
}

const ChangeOptionRecipeRawProducts = () => {
  const [step, setStep] = useState(ChangeOptionRecipeRawProductsStep.SelectRawProducts);

  const [changeRawProductOperations, setChangeRawProductOperations] = useState<ChangeRawProductOperation[]>([]);
  const [selectedSpecs, setSelectedSpecs] = useState<Spec[]>([])

  const { mutate, data: updateSubRecipeDetailsRawProductsResponse } = useUpdateSubRecipeDetailsRawProducts();
  const updates = updateSubRecipeDetailsRawProductsResponse?.data || []

  const reset = () => {
    setChangeRawProductOperations([])
    setSelectedSpecs([])
    setStep(ChangeOptionRecipeRawProductsStep.SelectRawProducts)
  }

  const renderStep = () => {
    switch (step) {
      case ChangeOptionRecipeRawProductsStep.SelectRawProducts:
        return (
            <SelectRawProducts
                changeRawProductOperations={changeRawProductOperations}
                setChangeRawProductOperations={setChangeRawProductOperations}
                setStep={setStep}
            />
        )
      case ChangeOptionRecipeRawProductsStep.SelectSpecs:
        return (
            <SelectSpecs
                setSelectedSpecs={setSelectedSpecs}
                setStep={setStep}
            />
        )
      case ChangeOptionRecipeRawProductsStep.ConfirmChanges:
        return (
            <ConfirmChanges
                changeRawProductOperations={changeRawProductOperations}
                selectedSpecs={selectedSpecs}
                mutate={mutate}
                setStep={setStep}
            />
        )
      case ChangeOptionRecipeRawProductsStep.Review:
        return (
            <Review
                updates={updates}
                reset={reset}
            />
        )
    }
  }

  return (
      <>
        <Header
            breadcrumb={{ to: '/optionrecipes', label: 'Back to Option Recipes' }}
            title="Change Option Recipe Raw Products"
            stepTracker={
              step !== ChangeOptionRecipeRawProductsStep.Review
                  ? {
                    currentStep: step,
                    steps: [
                      {
                        label: 'Select Raw Products',
                        onClick: () => setStep(ChangeOptionRecipeRawProductsStep.SelectRawProducts)
                      },
                      { label: 'Select Specs', onClick: () => setStep(ChangeOptionRecipeRawProductsStep.SelectSpecs) },
                      { label: 'Confirm Changes' }
                    ]
                  }
                  : undefined
            }
        />
        <ChangeRawProductsBody>
          {renderStep()}
        </ChangeRawProductsBody>
      </>
  )
}

export default ChangeOptionRecipeRawProducts;